import React from 'react';
import styled from 'styled-components';
import { BoldSmallBodyText, Button, NavigationItem } from 'ui-toolkit';
import { bullet, rightChevron } from '../../../../../../utilities/order/magicStrings';
import { urlGenerator } from '../../../../../../utilities/order/urlGenerator';

const StyledButton = styled(Button)`
  color: ${(props) => props.theme.colors.error};
  margin-left: ${(props) => props.theme.spacing.spacing5};
`;

const StyledDiv = styled.div`
  border-bottom: solid 1px ${(props) => props.theme.colors.gray};
  margin-bottom: ${(props) => props.theme.spacing.spacing4};
  padding-bottom: ${(props) => props.theme.spacing.spacing4};

  :last-child {
    border-bottom-width: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export interface IOrderLinkProps {
  associatedOrderId: string;
  associatedOrderNumber: string;
  associatedOrderType?: string | null;
  associatedOrderCancelled: boolean;
  onDisassociate: () => void;
  orderType?: string | null;
  orderCancelled: boolean;
}

export const OrderLink: React.FC<IOrderLinkProps> = ({
  associatedOrderId,
  associatedOrderNumber,
  associatedOrderType,
  associatedOrderCancelled,
  onDisassociate,
  orderType,
  orderCancelled,
}) => (
  <StyledDiv>
    <StyledDiv>
      <BoldSmallBodyText>
        Associated Order
        {associatedOrderCancelled ? ' (Cancelled)' : null}
      </BoldSmallBodyText>
      {associatedOrderType ? (
        <>
          {associatedOrderType}
          {` ${bullet} `}
        </>
      ) : null}
      <NavigationItem
        text={`${associatedOrderNumber} ${rightChevron}`}
        href={urlGenerator.urlFor.orderStatus(associatedOrderId)}
        isInline
      />
      <StyledButton intent="ghost" isInline onClick={onDisassociate}>
        Disassociate
      </StyledButton>
    </StyledDiv>
    {orderType ? (
      <StyledDiv>
        <BoldSmallBodyText>
          This Order
          {orderCancelled ? ' (Cancelled)' : null}
        </BoldSmallBodyText>
        {orderType}
      </StyledDiv>
    ) : null}
  </StyledDiv>
);
